import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminCheck } from "../../hooks/useAdminCheck";
import StickWomanSpinner from "../Spinners/StickWomanSpinner";

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAdmin, loading } = useAdminCheck();

  if (loading || isAdmin === null) return <StickWomanSpinner />;

  if (!isAdmin) return <Navigate to="/login-page" replace />;

  return <>{children}</>;
};

export default AdminRoute;
